import Attendants from '@/features/attendants'
import { listAttendantsQuery } from '@/queries/attendant.query'
import { listDepartmentsQuery } from '@/queries/department.query'
import { AttendantFilters } from '@/types/filters/attendant'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/attendants/')({
  component: Attendants,
  head: () => ({
    meta: [{
      title: 'Atendentes | Wazai',
    }]
  }),
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(listAttendantsQuery)
    await context.queryClient.ensureQueryData(listDepartmentsQuery)
  },
  validateSearch: () => ({}) as AttendantFilters,
})
